import React, { useEffect, useRef, useState } from "react";
import {
  Button,
  Flex,
  FormControl,
  FormLabel,
  Heading,
  Input,
  Stack,
  useColorModeValue,
  Avatar,
  Center,
  Image,
} from "@chakra-ui/react";
import axios from "axios";
import { useNavigate } from "react-router";
import { BASE_URL_MEDIA, BASE_URL_USER } from "../../Redux/App/action";

const UpdateProfile = () => {
  const [name, SetName] = useState("");
  const [email, SetEmail] = useState("");
  const [dob, SetDob] = useState("");
  const imageRef = useRef(null);
  const [data, setData] = useState([]);
  const [image, setImage] = useState("");
  const navigate = useNavigate();
  const accessToken = localStorage.getItem("token");
  const today = new Date().toISOString().split("T")[0];
  const handleClickImage = () => {
    imageRef.current.click();
  };
  const hangleImageChange = (event) => {
    const file = event.target.files[0];

    setImage(file);
  };

  const [profileData, setProfileData] = useState([]);
  const [sId, setSId] = useState(0);
  const [imageData, setImageData] = useState("");
  const getProfileData = async () => {
    try {
      const response = await axios.get(
        `${BASE_URL_USER}/api/v1/user/get-profile`,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${accessToken}`,
          },
        }
      );
      if (response.status === 200) {
        setProfileData(response.data.payload);
        console.log(
          response.data.payload.userImg,
          "sourceMediaId of user profile"
        );
        setSId(response.data.payload.userImg);
      }
    } catch (error) {
      console.clear(error);
    }
  };

  const getProfileImage = async () => {
    try {
      const response = await axios.get(
        `${BASE_URL_MEDIA}/media/file/admin/get/base64?sourceMediaId=${sId}&dimension=ORIGINAL`,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${accessToken}`,
          },
        }
      );
      if (response.status === 200) {
        setImageData(response.data);
      }
    } catch (error) {
      console.clear(error);
    }
  };

  useEffect(() => {
    getProfileData();
    getProfileImage();
  }, [sId]);
  useEffect(() => {
    SetName(profileData.fullName || "");
    SetEmail(profileData.email || "");
    SetDob(profileData.dob || "");
    setData(profileData.userImg || "");
  }, [profileData]);

  const handleImage = () => {
    const formData = new FormData();
    formData.append("imageGroup ", "PROFILE");
    formData.append("file", image);
    console.log(image);
    axios
      .post(
        `${BASE_URL_MEDIA}/media/file/admin/upload/private?imageGroup=PROFILE`,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
            Authorization: `Bearer ${accessToken}`,
          },
        }
      )
      .then((response) => {
        setData(response.data[0].sourceMediaId);
      })
      .catch((error) => {
        console.error(error);
      });
  };

  const handleSubmit = () => {
    const formData = new FormData();
    if (!email.includes("@") || !email.includes(".")) {
      alert("Please enter a valid email address");
    } else {
      formData.append("email", email);
    }
    formData.append("fullName", name);
    formData.append("dob", dob);
    formData.append("userImg", data);
    formData.append("userProfileId", data);
    axios
      .post(`${BASE_URL_USER}/api/v1/user/create-profile`, formData, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${accessToken}`,
        },
      })
      .then((response) => {
        setData(response.data);
        navigate("/myprofile");
      })
      .catch((error) => {
        console.clear(`${error.message}`);
        console.error(error);
      });
  };

  return (
    <Flex
      minH={"100vh"}
      align={"center"}
      justify={"center"}
      bg={useColorModeValue("gray.50", "gray.800")}
    >
      <Stack
        spacing={4}
        w={"full"}
        maxW={"md"}
        bg={useColorModeValue("white", "gray.700")}
        rounded={"xl"}
        boxShadow={"lg"}
        p={6}
      >
        <Heading lineHeight={1.1} fontSize={{ base: "2xl", sm: "3xl" }}>
          Profile Update
        </Heading>
        <FormControl id="userImg">
          <Stack direction={["column", "row"]} spacing={6}>
            <Center>
              {image ? (
                <Avatar size="xl" src={URL.createObjectURL(image)}></Avatar>
              ) : (
                <Avatar
                  size="xl"
                  src={
                    imageData === null
                      ? "https://media.istockphoto.com/id/1300845620/vector/user-icon-flat-isolated-on-white-background-user-symbol-vector-illustration.jpg?s=612x612&w=0&k=20&c=yBeyba0hUkh14_jgv1OKqIH0CCSWU_4ckRkAoy2p73o="
                      : `data:image/png;base64,${imageData}`
                  }
                ></Avatar>
              )}
            </Center>
            <Center w="full">
              <input
                type="file"
                ref={imageRef}
                onChange={hangleImageChange}
                style={{ display: "none" }}
              />
              <Flex gap={2}>
                <Button w="full" onClick={handleClickImage}>
                  Change Icon
                </Button>
                <Button onClick={handleImage}>save</Button>
              </Flex>
            </Center>
          </Stack>
        </FormControl>
        <FormControl id="name" isRequired>
          <FormLabel>Name</FormLabel>
          <Input
            placeholder="Enter Full Name"
            _placeholder={{ color: "gray.500" }}
            type="text"
            defaultValue={profileData.fullName}
            onChange={(e) => SetName(e.target.value)}
            onKeyPress={(e) => {
              const regex = /^[A-Za-z\s]+$/; // Allow letters and spaces
              const isValid = regex.test(e.key);
              if (!isValid) {
                e.preventDefault();
              }
            }}
          />
        </FormControl>
        <FormControl id="email" isRequired>
          <FormLabel>Email address</FormLabel>
          <Input
            placeholder="your-email@example.com"
            _placeholder={{ color: "gray.500" }}
            type="email"
            defaultValue={profileData.email}
            onChange={(e) => SetEmail(e.target.value)}
          />
        </FormControl>
        <FormControl id="dob" isRequired>
          <FormLabel>Date of Birth</FormLabel>
          <Input
            placeholder="DOB"
            _placeholder={{ color: "gray.500" }}
            type="date"
            max={today}
            defaultValue={profileData.dob}
            onChange={(e) => SetDob(e.target.value)}
          />
        </FormControl>
        <Stack spacing={6} direction={["column", "row"]}>
          <Button
            bg={"red.400"}
            color={"white"}
            w="full"
            _hover={{
              bg: "red.500",
            }}
            onClick={() => navigate("/myprofile")}
          >
            Cancel
          </Button>
          <Button
            bg={"blue.400"}
            color={"white"}
            w="full"
            _hover={{
              bg: "blue.500",
            }}
            onClick={handleSubmit}
          >
            Submit
          </Button>
        </Stack>
      </Stack>
    </Flex>
  );
};

export default UpdateProfile;
